import React from 'react';
import { Heart, Sparkles, Shield, Flame, Eye, DollarSign, Briefcase, Star } from 'lucide-react';
import { services } from '../mockData';

const iconMap = {
  Heart,
  Sparkles,
  Shield,
  Flame,
  Eye,
  DollarSign,
  Briefcase,
  Star
};

const Services = () => {
  return (
    <section id="services" className="py-16 md:py-32 px-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900/50 to-black"></div>
      
      <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-amber-600/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto relative z-10">
        <div className="text-center mb-12 md:mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 display-font">
            Nos <span className="gold-text">Services de Magie</span>
          </h2>
          <div className="w-32 h-1 divider-glow mx-auto mb-6"></div>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto serif-font">
            Solutions mystiques puissantes pour tous vos problèmes de vie
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <div 
                key={service.id}
                className="card-hover glass rounded-3xl p-8 group relative overflow-hidden"
                style={{animationDelay: `${index * 0.1}s`}}
              >
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-yellow-600/20 to-transparent rounded-full blur-2xl group-hover:scale-150 transition-transform duration-500"></div>
                
                <div className="relative z-10">
                  <div className="w-16 h-16 bg-gradient-to-br from-yellow-600 to-amber-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-lg">
                    <Icon className="text-white" size={32} />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-4 display-font">{service.title}</h3>
                  <p className="text-gray-400 leading-relaxed">{service.description}</p>
                </div>
                
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-yellow-500 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
            );
          })}
        </div>
        
        <div className="mt-16 text-center">
          <a 
            href="#contact"
            className="inline-flex items-center space-x-3 luxury-button text-white px-10 py-5 rounded-full font-bold text-lg"
          >
            <Sparkles size={22} />
            <span>Demander une consultation</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;